import moment from 'moment';
import 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { callEndpoint, telemetry } from '../../../../services/backend';
import { getReminders } from '../../../../services/reminders';
import { ROUTE_REMINDERS } from '../../../../services/route/route-names';
import { transitionToNextRoute } from '../../../../services/route/route-navigation';
import { setSideBarNoMenu } from '../../../../services/store/modules/app-controls';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import PlaceHolderMessage from '../../../shared/_deprecated/components/PlaceHolderMessage/PlaceHolderMessage';
import RemindersCreateForm from '../RemindersCreateForm/RemindersCreateForm';

class RemindersEditPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      loading: false,
      date: '',
      label: '',
      submitting: false,
    };

    this.updateProperty = (property, value) => {
      this.setState({
        [property]: value,
      });
    };

    // Get any reminders from the entity store
    this.getReminderItem = async () => {
      this.setState({
        loading: true,
      });

      const { myRemindersItemId } = this.props;

      try {
        const myReminders = await getReminders();
        const myRemindersItems = await myReminders.reminders;

        const myRemindersItem = myRemindersItems.find(
          // eslint-disable-next-line eqeqeq
          (item) => item.id == myRemindersItemId,
        );

        // Format the date
        const formatedDate = moment(myRemindersItem.expiryDate).format(
          'YYYY-MM-DD',
        );

        this.setState({
          date: formatedDate,
          label: myRemindersItem && myRemindersItem.label,
          loading: false,
        });
      } catch (err) {
        telemetry(
          // eslint-disable-next-line no-bitwise
          telemetry.ERROR | telemetry.NOTIFY_SYSTEM_CHANNEL,
          '[RemindersEditPage.getReminderItem] error loading reminder',
          err,
        );
        this.setState({
          loading: false,
          error: 'There was an error editing the reminder.',
        });
      }
    };

    // Delete the reminder item from the entity store
    this.deleteItem = async () => {
      const { myRemindersItemId } = this.props;

      await callEndpoint(callEndpoint.endpoints.deleteReminder, {
        id: myRemindersItemId,
      });

      telemetry(
        telemetry.DEBUG,
        `[RemindersEditPage.delete] deleting reminder item ${myRemindersItemId}`,
      );
      transitionToNextRoute(ROUTE_REMINDERS);
    };

    this.submit = async () => {
      try {
        this.setState({
          submitting: true,
        });

        const { myRemindersItemId, myRemindersItemType } = this.props;

        const { date, label } = this.state;

        const midnightTimeSting = '00:00:00';
        const expiryDate = +moment(`${date} ${midnightTimeSting}`).format('x');
        const expiryTimezone = moment.tz.guess();

        const editedReminderData = {
          id: myRemindersItemId,
          myRemindersItemType,
          expiryDate,
          expiryTimezone,
          label,
        };

        telemetry(
          telemetry.DEBUG,
          `[RemindersEditPage.submit] submitting reminder data ${JSON.stringify(
            editedReminderData,
          )}`,
        );
        const returnedData = await callEndpoint(
          callEndpoint.endpoints.editReminder,
          { ...editedReminderData },
        );
        telemetry(
          telemetry.DEBUG,
          `[RemindersEditPage.submit] received back reminder data ${JSON.stringify(
            returnedData,
          )}`,
        );

        transitionToNextRoute(ROUTE_REMINDERS);

        this.setState({
          submitting: false,
        });
      } catch (error) {
        telemetry(
          /* eslint-disable-next-line no-bitwise */
          telemetry.ERROR | telemetry.NOTIFY_SYSTEM_CHANNEL,
          '[RemindersEditPage.submit] error submitting reminder',
          error,
        );
        this.setState({
          error: 'There was an error editing the reminder.',
          submitting: false,
        });
      }
    };
  }

  componentDidMount() {
    const { dispatchSetSideBarNoMenu } = this.props;

    dispatchSetSideBarNoMenu();
    this.getReminderItem();
  }

  render() {
    const { error, loading, submitting, date, label } = this.state;

    return (
      <BasicDrawerLayout
        showMapOverlay
        heading={label || 'Edit reminder'}
        onBack={() => transitionToNextRoute(ROUTE_REMINDERS)}
        onClose={null}
        loading={submitting || loading}
      >
        {!submitting && !loading && !error && (
          <RemindersCreateForm
            updateField={this.updateProperty}
            submitting={submitting}
            submit={this.submit}
            label={label}
            date={date}
            showDeleteItemButton
            deleteItem={this.deleteItem}
          />
        )}

        {error && (
          <PlaceHolderMessage heading="Error" description={error} addPadding />
        )}
      </BasicDrawerLayout>
    );
  }
}

RemindersEditPage.propTypes = {
  myRemindersItemId: PropTypes.string.isRequired,
  myRemindersItemType: PropTypes.string.isRequired,
  dispatchSetSideBarNoMenu: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  dispatchSetSideBarNoMenu: () => dispatch(setSideBarNoMenu({})),
});

export default connect(mapStateToProps, mapDispatchToProps)(RemindersEditPage);
